import React from 'react';
import {MasterLayout} from 'layout';
import { XuLyTheoDoiThucHien } from 'modules/theo-doi-thuc-hien';

class XuLyTheoDoiThucHienPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <XuLyTheoDoiThucHien params={this.props.params}/>
      </MasterLayout>
    );
  }
}

export default XuLyTheoDoiThucHienPage;


// WEBPACK FOOTER //
// ./src/components/pages/theo-doi-thuc-hien/XuLyTheoDoiThucHienPage.jsx